import React from 'react';
import PropTypes from 'prop-types';

const TextInput = ({ type, name, value, title, placeholder, required, disabled, className, handleChange }) => {
  return (
    (
      type === 'text' &&
      <input
        type={type}
        name={name}
        value={value}
        title={title}
        placeholder={placeholder}
        className={className}
        required={required}
        disabled={disabled}
        onChange={handleChange}
      />
    ) ||
    (
      type === 'textarea' &&
      <textarea
        name={name}
        title={title}
        placeholder={placeholder}
        className={className}
        required={required}
        disabled={disabled}
        onChange={handleChange}
      >
        {value}
      </textarea>
    )
  );
};

TextInput.propTypes = {
  type: PropTypes.oneOf([
    'text',
    'textarea'
  ]).isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func.isRequired
};

TextInput.defaultProps = {
  type: 'text',
  name: 'text-input',
  value: '',
  title: '',
  placeholder: '',
  required: false,
  disabled: false
};

export default TextInput;
